import { Badge } from '@mantine-8/core';
import { type FC } from 'react';

export const ServiceAccountBadge: FC = () => (
    <Badge size="xs" variant="light" color="violet" radius="sm">
        Service account
    </Badge>
);
